import React from "react";
import { Mail, ShoppingBag, ExternalLink } from "lucide-react";

export const Orders = () => {
  const takealotUrl = "https://www.takealot.com/all?qsearch=gold+bar+vape";

  return (
    <section
      id="orders"
      className="relative py-16 sm:py-20 px-6 md:px-12 border-t border-white/5"
      data-testid="orders-section"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-10">
        {/* Section header */}
        <div className="flex flex-col gap-4 max-w-2xl">
          <p className="text-misty-steel text-[10px] sm:text-xs tracking-[0.5em] uppercase font-semibold">
            Where to Buy
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-misty-text tracking-wide leading-[0.95]">
            Orders
          </h2>
          <div className="w-16 h-px bg-misty-steel/60 mt-2" />
          <p className="text-misty-muted leading-relaxed text-base sm:text-lg mt-2">
            Gold Bar and Titan vapes are available online at{" "}
            <span className="text-misty-text">Takealot.com</span>. For trade,
            distributor and bulk enquiries, please reach our orders team
            directly.
          </p>
        </div>

        {/* Two-card layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Takealot card */}
          <a
            href={takealotUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative flex flex-col gap-8 bg-misty-surface border border-white/5 p-8 sm:p-12 transition-all duration-300 hover:border-misty-steel/50"
            data-testid="orders-takealot-card"
          >
            <div className="flex items-center gap-3">
              <ShoppingBag size={16} className="text-misty-steel" />
              <p className="text-misty-steel text-xs tracking-[0.3em] uppercase font-semibold">
                Shop Online
              </p>
            </div>

            <div className="flex-1 flex items-center justify-center min-h-[140px] bg-misty-base border border-white/5 py-6 px-6">
              <img
                src="https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/rjb2c2ps_Takealot_logo.svg.png"
                alt="Takealot.com"
                className="h-20 sm:h-24 w-auto object-contain"
                data-testid="takealot-logo"
              />
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="font-display text-3xl sm:text-4xl text-misty-text tracking-wide leading-none">
                Available on Takealot
              </h3>
              <p className="text-misty-muted leading-relaxed text-sm sm:text-base">
                Gold Bar and Titan vape products are listed on Takealot.com —
                South Africa's leading online marketplace. Browse the full
                range, read reviews, and order with nationwide delivery.
              </p>
            </div>

            <div className="inline-flex items-center gap-2 text-misty-steel group-hover:text-misty-steelHi transition-colors text-xs tracking-[0.2em] uppercase font-semibold pt-2 border-t border-white/5">
              <span>Visit Takealot</span>
              <ExternalLink
                size={14}
                className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-0.5"
              />
            </div>
          </a>

          {/* Direct orders card */}
          <div
            className="relative flex flex-col gap-8 bg-misty-surface border border-white/5 p-8 sm:p-12 transition-all duration-300 hover:border-misty-steel/50"
            data-testid="orders-direct-card"
          >
            <div className="flex items-center gap-3">
              <Mail size={16} className="text-misty-steel" />
              <p className="text-misty-steel text-xs tracking-[0.3em] uppercase font-semibold">
                Trade & Bulk Orders
              </p>
            </div>

            <div className="flex-1 flex items-center justify-center min-h-[120px] bg-misty-base border border-white/5 py-8 px-6">
              <div className="flex flex-col items-center gap-2">
                <p className="text-misty-dim text-[10px] tracking-[0.4em] uppercase">
                  Contact Us
                </p>
                <a
                  href="mailto:orders@mistydistribution.com"
                  className="font-display text-2xl sm:text-3xl text-misty-text hover:text-misty-steel transition-colors tracking-wide text-center"
                  data-testid="orders-email-link"
                >
                  orders@mistydistribution.com
                </a>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="font-display text-3xl sm:text-4xl text-misty-text tracking-wide leading-none">
                Direct Enquiries
              </h3>
              <p className="text-misty-muted leading-relaxed text-sm sm:text-base">
                Distributors, retailers and high-volume buyers can place orders
                or request a wholesale quote by emailing our dedicated orders
                team. We typically respond within one working day.
              </p>
            </div>

            <a
              href="mailto:orders@mistydistribution.com"
              className="inline-flex items-center gap-2 text-misty-steel hover:text-misty-steelHi transition-colors text-xs tracking-[0.2em] uppercase font-semibold pt-2 border-t border-white/5"
              data-testid="orders-email-cta"
            >
              <span>Email Orders Team</span>
              <Mail size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
